import classnames from 'classnames';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import { SUPPORT_LINK } from '../../helpers/constants';
import { ConnectionItemShape } from '../../helpers/propTypeShapes';
import { maxLength, notBlank, required, validate } from '../../helpers/validation';
import CustomPasswordFormField from '../CustomPasswordFormField';

export default function PigeonHoleForm({ handleOnConnectionFormChange, connection, setIsFormValid }) {
  const isUpdateAction = useMemo(() => Boolean(connection.hash), [connection.hash]);
  const [inputErrors, setInputErrors] = useState({});
  const [visitedInputs, setVisitedInputs] = useState({});

  useEffect(() => {
    const apiKeyRules = isUpdateAction ? [maxLength(64), notBlank()] : [required(), maxLength(64), notBlank()];

    const errors = validate(connection, {
      title: [required(), maxLength(126), notBlank()],
      apiKey: apiKeyRules,
    });

    setInputErrors(errors);
    setIsFormValid(Object.keys(errors).length === 0);
  }, [connection, isUpdateAction, setIsFormValid]);

  const handleOnBlur = (event) => {
    const propertyName = event.target.name;
    setVisitedInputs((inputs) => ({ ...inputs, [propertyName]: true }));
  };

  const apiKeyLabel = useMemo(
    () => (
      <div className="label-with-help-link">
        pigeonhole api key token
        <a href={SUPPORT_LINK.SETTING_UP_PIGEONHOLE} target="_blank" rel="noreferrer">
          HELP
          <i className="icon icon-info-circle" />
        </a>
      </div>
    ),
    []
  );

  return (
    <div>
      <div className="form-group">
        <label htmlFor="connection-title">
          Integration title
          <input
            className={classnames({ 'has-error': Boolean(inputErrors.title) && visitedInputs.title })}
            id="connection-title"
            name="title"
            value={connection.title}
            onBlur={handleOnBlur}
            onChange={(event) => handleOnConnectionFormChange({ ...connection, title: event.target.value })}
          />
        </label>
      </div>

      {isUpdateAction ? (
        <CustomPasswordFormField
          label={apiKeyLabel}
          name="apiKey"
          onBlur={handleOnBlur}
          errorClass={Boolean(inputErrors.apiKey) && visitedInputs.apiKey ? 'has-error' : ''}
          handleOnFieldChange={(value) => handleOnConnectionFormChange({ ...connection, apiKey: value })}
        />
      ) : (
        <div className="form-group">
          <label htmlFor="connection-apiKey">
            {apiKeyLabel}
            <input
              className={classnames({ 'has-error': Boolean(inputErrors.apiKey) && visitedInputs.apiKey })}
              id="connection-apiKey"
              name="apiKey"
              onBlur={handleOnBlur}
              onChange={(event) => {
                handleOnConnectionFormChange({ ...connection, apiKey: event.target.value });
                handleOnBlur(event);
              }}
            />
          </label>
        </div>
      )}
    </div>
  );
}

PigeonHoleForm.propTypes = {
  connection: ConnectionItemShape.isRequired,
  handleOnConnectionFormChange: PropTypes.func.isRequired,
  setIsFormValid: PropTypes.func.isRequired,
};
